import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Wrench, FileText, Package, Boxes, Search } from "lucide-react";
import { useLang } from "@/i18n";
import { useStats } from "@/context/StatsContext";

const Card = ({ icon: Icon, label, value, suffix, color, late, lateLabel, onClick, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className="cb-lift group relative flex items-center gap-2 rounded-lg border border-border/70 bg-card px-2.5 py-1.5 text-left shadow-sm transition-colors duration-150 hover:bg-secondary/60 touch-manipulation">
    <Icon className="h-3.5 w-3.5 shrink-0 text-primary" />
    <span title={label} className="flex-1 min-w-0 truncate text-[10px] font-bold uppercase tracking-[0.1em] text-muted-foreground leading-tight">{label}</span>
    <span className="flex items-center gap-1.5 shrink-0">
      {late > 0 && (
        <span title={lateLabel} data-testid={`${testid}-late`}
          className="inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-rose-600 px-1 text-[10px] font-bold text-white tabular-nums">{late}</span>
      )}
      <span className="font-display text-lg font-black leading-none tabular-nums tracking-tight" style={color ? { color } : undefined}>
        {value}{suffix && <span className="text-xs font-bold text-muted-foreground">{suffix}</span>}
      </span>
    </span>
  </button>
);

export default function KpiBar() {
  const { t } = useLang();
  const { stats } = useStats();
  const nav = useNavigate();
  if (!stats) return null;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2 mb-3" data-testid="kpi-bar">
      <Card icon={Search} label={t("nav_zoekers")} value={stats.zoekers ?? 0} onClick={() => nav("/aankomend")} testid="kpi-zoekers" />
      <Card icon={LogOut} label={t("kpi_departures")} value={stats.departing_today ?? 0} late={stats.departing_late || 0} lateLabel={t("kpi_overdue")} onClick={() => nav("/vertrekkend")} testid="kpi-departures" />
      <Card icon={Wrench} label={t("nav_jobs")} value={stats.jobs_open ?? 0} late={stats.jobs_unassigned || 0} lateLabel={t("job_unassigned")} onClick={() => nav("/jobs")} testid="kpi-jobs" />
      <Card icon={FileText} label={t("kpi_open_invoices")} value={stats.open_invoices ?? 0} onClick={() => nav("/facturen")} testid="kpi-invoices" />
      <Card icon={Package} label={t("nav_verhuur")} value={stats.rentals_back_today ?? 0} late={stats.late_rentals || 0} lateLabel={t("rental_overdue")} onClick={() => nav("/verhuur")} testid="kpi-rentals" />
      <Card icon={Boxes} label={t("kpi_stock")} value={stats.stock_total ?? 0} late={stats.stock_negative || 0} lateLabel={t("kpi_stock_negative")} onClick={() => nav("/admin/voorraad")} testid="kpi-stock" />
    </div>
  );
}
